import type { RuptureContent } from '../fr/rupture';

export const RUPTURE: RuptureContent = {
  label:         'What sets me apart',
  titleLead:     'I do not write software.',
  titleStrong:   'I design ',
  titleEmphasis: 'ways of working',
  paragraphs: [
    'Fourteen years inspecting hydroelectric dam components — complex, precise, up to several tonnes — implementing, maintaining and improving quality systems — ISO 9001, CMMS, dedicated applications — and delivering quality packages to Hydro-Québec, GE, Voith and Andritz. Everything I design today was shaped by those years on the shop floor.',
    'When technology is what is needed, I build it. When the process is the problem, I rethink it. The goal never changes: cut the waste, raise reliability, and leave the organization running better than I found it. Asterion Solutions grew out of that.',
  ],
  chipBefore: 'Shop-floor expertise',
  chipAfter:  'Method & tools',
  chipResult: 'Measurable results',
};
